import { VFC, useMemo } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { TubeMaterial } from '@enmon/commons';
import { Select } from '../../Select';
import { MeterDetails as messages } from '../../../Form/meter_details/messages';
import { tubeMaterialTranslated } from '../../../Form/meter_details/constants';
import { useMeterModelSuggestionsStore } from '../../../../store/useMeterModelSuggestionsStore';
import { getSelectOptionsWithSuggestions } from '../../utils/getSelectOptionsWithSuggestions';

interface TubeMaterialSelectProps {
  value?: TubeMaterial;
  onChange?: (value: TubeMaterial) => void;
}

export const TubeMaterialSelect: VFC<TubeMaterialSelectProps> = ({ ...restProps }) => {
  const intl = useIntl();
  const { meterModelSuggestions } = useMeterModelSuggestionsStore();

  const tubeMaterialOptions = useMemo(
    () =>
      getSelectOptionsWithSuggestions({
        intl,
        values: Object.values(TubeMaterial),
        suggestedValue: meterModelSuggestions?.tubeMaterial?.value,
        suggestedSelection: meterModelSuggestions?.tubeMaterial?.selection,
        labelFormatter: (value: TubeMaterial) => intl.formatMessage(tubeMaterialTranslated[value]),
      }),
    [meterModelSuggestions, intl],
  );

  return (
    <Select
      allowClear
      showArrow
      className="w-100"
      options={tubeMaterialOptions}
      placeholder={<FormattedMessage {...messages.tubeMaterialPlaceholder} />}
      {...restProps}
    />
  );
};
